import * as React from 'react';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {getChildren} from '@packages/utilities/data-utils';

const Layout = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    // wf-layout-layout adds a default class style to the Layout element
    // Found in bootflow-layout.css
    const layoutClasses = classes.push('wf-layout-layout');
    return (
      <div {...generateAttributes(attributes, layoutClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </div>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Quick Stack',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Layout'), iconName('Layout')),
  },
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          gridAutoColumns: '1fr',
          gridRowGap: '20px',
          gridColumnGap: '20px',
          paddingTop: px(20),
          paddingRight: px(20),
          paddingBottom: px(20),
          paddingLeft: px(20),
          justifyContent: 'center',
        },
      },
    },
  },
  render: Layout,
  fields: {children: TListOfElement},
  constraints: {
    children: [
      {
        is: 'Cell',
        name: 'Non-Cell Item',
        rule: 'RequireOnly',
        messages: {
          move: 'Elements must be added to cells.',
          paste: 'Elements must be added to cells.',
        },
      },
    ],
  },
});

export default config;
